export const AI_AGENTS_WORKSPACE_PATH = '/home/ai-agents';

export const LIVE_CHAT_WORKSPACE_PATH = '/home/ai-agents?type=general';

export const LEGACY_LIVE_CHAT_CHANNELS_PATH = '/home/live-chat';
